import {
  required as requiredEs,
  validateNIT as validateNITEs,
  validateCvv as validateCvvEs,
  validateExpirationDate as validateExpirationDateEs,
  composeValidators,
  validateEmail,
  phoneNumber,
  onlyText,
  onlyNumbers,
  cardLength,
} from "./validators";

export { composeValidators, validateEmail, phoneNumber, onlyText, onlyNumbers, cardLength };

export const required = (value, allValues) =>
  requiredEs(value, allValues) ? "Required field" : undefined;

export const validateNIT = (value) =>
  validateNITEs(value) ? "Invalid NIT" : undefined;

export const validateCvv = (value) =>
  validateCvvEs(value) ? "Please enter a valid CVV" : undefined;

const EXPIRATION_MESSAGES = {
  "Formato MM/AA requerido": "MM/YY format required",
  "Mes inválido (01-12)": "Invalid month (01-12)",
  "Fecha de expiración inválida": "Invalid expiration date",
};

export const validateExpirationDate = (value) => {
  const error = validateExpirationDateEs(value);
  return error ? EXPIRATION_MESSAGES[error] || error : undefined;
};
